import * as React from "react";
import { useForm } from "react-hook-form";
import { useDataLoader } from "react-remote-data-hooks";
import { useHistory } from "react-router-dom";
import api from "../../api";
import { AppLayout, Dict, SortOrder, User, formatDate } from "../../core";
import {
  SiteVisit,
  SiteVisitPropertyData,
  SiteVisitScheduleDetails,
  SiteVisitSchedulePreviewDetails,
  Location,
} from "../../core/api/models/sitevisit";
import { IBigCalendarResource } from "../../core/components/calendar/big-calendar-component";
import "../../styles/full-view-popup.scss";
import "../../styles/requirement.scss";
import "../../styles/sales-person.scss";
import "../../styles/tags.scss";
import { StatusCodes } from "http-status-codes";
import { toastr } from "react-redux-toastr";
import BlankProPic from "../../styles/images/no-user-sm.png";
import BlankImage from '../../assets/images/color-noimage-lg.png'
import PropertyDetailPage from "../property-details/PropertyDetailPage";
interface IPropertyDetailsPageProps {
  siteVisit: SiteVisit;
  propertyDetails: SiteVisitSchedulePreviewDetails[];
  renderLocation: (location: Location) => JSX.Element;
  onClickEdit: () => void;
  onClose: () => void;
  reload?: () => void;
  onSiteVisitConfirm?: () => void;
  isReschedule?: boolean;
}

const ScheduleSiteVisitPreview: React.FunctionComponent<IPropertyDetailsPageProps> = (
  props
) => {
  const history = useHistory();
  const [uploading, setUploading] = React.useState<boolean>(false);
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [detailModal, setDetailModal] = React.useState<{
    isOpen?: boolean;
    id?: string;
  }>({});
  const [
    currentSelectedPropertyDetail,
    setCurrentSelectedPropertyDetail,
  ] = React.useState<{
    currentSelectedPropertyId?: string;
    date?: Date;
    start?: string;
    end?: string;
    landlord?: User[];
  }>({ date: new Date() });
  const setPropertyDetail = (update: {
    [key: string]: string | Date | User[];
  }) => {
    setCurrentSelectedPropertyDetail({
      ...(currentSelectedPropertyDetail || {}),
      ...update,
    });
  };

  const onClose = () => {
    props.onClose();
  };

  const renderHeader = () => {
    return (
      <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
        <div className="row align-items-center">
          <div className="col-auto" onClick={onClose}>
            <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
          </div>
          <div className="col-auto font-base font-weight-bold">
            Schedule a site visit
          </div>
          <div className="col-auto">
            <div className="font-xxs font-weight-semibold px-2 bg-orange-light py-1 rounded text-gray-800">
              Pending Visit Schedule
            </div>
          </div>
          <div className="col-auto mt-md-0 mt-1 ml-auto">
            <span className="bg-white d-inline-block mr-2">
              <button
                type="button"
                className="btn btn-outline-secondary px-5 font-normal font-weight-bold py-2 rounded"
                style={{ height: "40px" }}
                onClick={props.onClickEdit}
              >
                Edit
              </button>
            </span>
            <button
              type="submit"
              disabled={uploading}
              className="btn btn-primary px-3 font-normal font-weight-bold py-2 rounded"
              style={{ height: "40px" }}
              onClick={onSubmit}
            >
              Confirm Schedule
            </button>
          </div>
        </div>
      </div>
    );
  };

  const onSubmit = async (data: Dict) => {
    setUploading(true);
    try {
      if(props.isReschedule){
        const response = await api.sitevisit.reSchedule(props.siteVisit?._id, props.propertyDetails?.map((p) => {
            return {
              ...p,
              agents: p.agents?.map((a) => a._id),
              landLords: p.landLords?.map((l) => l._id),
            };
          })?.[0],
        );
        if (response.status === StatusCodes.OK) {
          props?.onSiteVisitConfirm?.();
          toastr.success("Success", "The site visit has been successfully rescheduled!");
          if (props.reload) {
            props.reload();
          }
          if (props.onClose) {
            props.onClose();
          }
        } else {
          toastr.error("Error", response?.message ? response?.message : "Something went wrong!");
        }
      }else{
        const response = await api.sitevisit.schedule(props.siteVisit?._id, {
          scheduleData: props.propertyDetails?.map((p) => {
            return {
              ...p,
              agents: p.agents?.map((a) => a._id),
              landLords: p.landLords?.map((l) => l._id),
            };
          }),
        });
        if (response.status === StatusCodes.OK) {
          props?.onSiteVisitConfirm?.();
          toastr.success("Success", "New Schedules added!");
          if (props.reload) {
            props.reload();
          }
          if (props.onClose) {
            props.onClose();
          }
        } else {
          toastr.error("Error", response?.message ? response?.message : "Something went wrong!");
        }
      }
    } catch (e) {
      toastr.error("Error", "Something went wrong!");
    }
    setUploading(false);
  };

  return (
    <AppLayout>
      <div className="">
        {/* {(!loaded || loading) && <ContainerLoader></ContainerLoader>} */}
        {/* {isSyncing && <ContainerLoader></ContainerLoader>} */}

        <>
          <div
            className="detail-poupup position-fixed top-0 w-100 h-100 overflow-auto in"
            style={{ maxWidth: "1258px" }}
          >
            {renderHeader()}
            <div className="container-fluid p-0 bg-white min-vh-100">
              <div className="h-100">
                <div className="">
                  <div
                    className="font-normal font-weight-bold py-2 border-bottom px-4 d-flex align-items-center justify-content-between"
                    style={{ height: "48px" }}
                  >
                    Select Date & Time, Client Participiants, Pickup/Drop Location
                  </div>

                  <div
                    className="col-12 row pb-3 border-bottom py-2 mx-0 px-2"
                    style={{ minHeight: "10vh" }}
                  >
                    <div className="col-3 column">
                      <label
                        className="font-sm font-weight-semibold mb-2"
                        htmlFor="preferredDates"
                      >
                        PREFERRED DATES
                      </label>
                      {props.siteVisit?.preferedDates?.map((preferedDate) => {
                        return (
                          <div className="mb-2 font-normal font-weight-semibold">
                            {formatDate(preferedDate.date!, "DD MMM YYYY")} -{" "}
                            {preferedDate.timing?.start} -{" "}
                            {preferedDate.timing?.end}{" "}
                          </div>
                        );
                      })}
                    </div>
                    <div className="col-3">
                      <label
                        className="font-sm font-weight-semibold mb-2"
                        htmlFor="preferredDates"
                      >
                        CLIENT PARTICIPANTS
                      </label>
                      {props.siteVisit?.participants?.map((participant) => {
                        return (
                          <div className="mb-3 font-normal font-weight-semibold">
                            <div className="d-flex align-items-center mr-3">
                              <img
                                src={participant?.profileImage || BlankProPic}
                                alt={
                                  participant?.profileImage || "property image"
                                }
                                className="img-cover rounded-circle img-responsive mr-2"
                                width="24"
                                height="24"
                              />
                              {`${participant?.firstName || ""} ${participant?.lastName || ""
                                }`}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="col-3">
                      <label
                        className="font-sm font-weight-semibold mb-1"
                        htmlFor="preferredDates"
                      >
                        PICK UP LOCATION
                      </label>
                      <div className="font-xs text-gray-800">
                        {props.siteVisit?.pickup?.address}
                      </div>
                    </div>
                    <div className="col-3">
                      <label
                        className="font-sm font-weight-semibold mb-1"
                        htmlFor="preferredDates"
                      >
                        DROP UP LOCATION
                      </label>
                      <div className="font-xs text-gray-800">
                        {props.siteVisit?.drop?.address}
                      </div>
                    </div>
                  </div>

                  <div className="">
                    {/* <div
                        className="font-normal font-weight-bold py-2 border-bottom px-4 d-flex align-items-center justify-content-between mb-2"
                        style={{ height: "48px" }}
                      >
                        Selected Properties
                      </div> */}
                    <div className="col-12 pb-3 px-0">
                      <table className="col-12">
                        <tr>
                          <th
                            colSpan={2}
                            className="font-normal font-weight-bold py-2 border-bottom px-4"
                            style={{
                              maxWidth: "90px",
                              width: "90px",
                              height: "48px",
                            }}
                          >
                            Selected Properties
                          </th>
                          <th
                            className="font-normal font-weight-bold py-2 border-bottom px-4"
                            style={{ height: "48px" }}
                          >
                            Date of Schedule
                          </th>
                          <th
                            className="font-normal font-weight-bold py-2 border-bottom px-4"
                            style={{ height: "48px" }}
                          >
                            Cityinfo Participants
                          </th>
                        </tr>
                        {props.propertyDetails?.map((propertyDetail) => {
                          const propertyDetails = props.siteVisit?.propertyDetails?.find(
                            (p) => p._id === propertyDetail?.propertyId
                          );
                          return (
                            <tr>
                              <td
                                className="py-2 border-bottom align-top pl-4"
                                style={{
                                  maxWidth: "114px",
                                  width: "114px",
                                }}
                              >
                                <div className="py-1">
                                  <img
                                    src={propertyDetails?.propertyCoverImage || BlankImage}
                                    // alt={item?.propertyDetails?.projectName}
                                    width={83}
                                    height={63}
                                    className="img-cover rounded"
                                  />
                                </div>
                              </td>
                              <td
                                className="py-2 border-bottom align-top"
                              // style={{ width: "290px", maxWidth: "290px" }}
                              >
                                <div className="py-1 w-100 px-2">
                                  <div className="font-sm text-truncate mb-1" role={'button'} onClick={() => {setDetailModal({
                                                isOpen: true,
                                                id: propertyDetails?._id,
                                                })
                                   }}>
                                    {propertyDetails?.propertyName}{" "}
                                  </div>
                                  <div className="font-sm text-truncate mb-1  d-flex align-items-center">
                                    <span className="text-muted">Type:</span>{" "}
                                    <span className="dot-separator d-inline-block bg-gray-400 rounded mx-2"></span>
                                    {propertyDetails?.propertyType}
                                    {/* <span className="text-muted">
                                      Developer:
                                    </span>{" "}
                                    {
                                      propertyDetails?.projectDetails
                                        ?.projectBuilderName?.developer
                                    } */}
                                    <span className="text-muted  mr-1 ml-1">
                                    Floor Number:
                                    </span>{" "}
                                    {
                                      propertyDetails?.unitDetails?.floorName
                                    }
                                  </div>
                                  <div className="font-xs text-gray-500 line-clamp-2  d-flex align-items-center mb-1 ">
                                    <span className="text-muted">Area:</span>{" "}
                                    {propertyDetails?.attribute?.builtUpArea}
                                    Sq.Ft{" "}
                                    {propertyDetails?.pricePerSqft && (
                                      <>
                                        <span className="dot-separator d-inline-block bg-gray-400 rounded mx-2"></span>{" "}
                                        ₹ {propertyDetails?.pricePerSqft}/Sq. Ft{" "}
                                      </>
                                    )}
                                  </div>
                                  <div className="font-sm text-truncate mb-1 text-gray-500">
                                    <i className="icon-location-filled mr-1"></i>
                                    {propertyDetails?.cityLocName}
                                  </div>
                                  {propertyDetail?.landLords?.map(
                                    (landLord) => {
                                      return (
                                        <>
                                          <div className="font-sm text-truncate mb-1  d-flex align-items-center">
                                            <span className="text-muted pr-1">
                                              Landlord User:
                                            </span>{" "}
                                            {landLord?.contactName}
                                          </div>
                                          <div className="font-sm text-truncate mb-1  d-flex align-items-center">
                                            <span className="text-muted pr-1">
                                              Landlord User Contact:
                                            </span>{" "}
                                            {landLord?.emails?.find(ml => ml.isPrimary)?.email || ''}
                                            <span className="dot-separator d-inline-block bg-gray-400 rounded mx-2"></span>{" "}
                                            {landLord?.phones?.find(ph => ph.isPrimary)?.phone || ''}
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                                </div>
                              </td>
                              <td
                                className="py-2 border-bottom align-top"
                              // style={{ width: "290px", maxWidth: "290px" }}
                              >
                                <div className="py-1 w-100 px-4 font-normal font-weight-semibold">
                                  {formatDate(
                                    propertyDetail?.scheduledDate?.date!,
                                    "DD MMM YYYY"
                                  )}{" "}
                                  -{" "}
                                  {propertyDetail?.scheduledDate?.timing?.start}{" "}
                                  - {propertyDetail?.scheduledDate?.timing?.end}{" "}
                                </div>
                              </td>
                              <td
                                className="py-2 border-bottom"
                              // style={{ width: "290px", maxWidth: "290px" }}
                              >
                                <div className="py-1 w-100 px-4 font-normal font-weight-semibold">
                                  {propertyDetail?.agents?.map((agent) => {
                                    return (
                                      <div className="mb-2 font-normal font-weight-semibold">
                                        <div className="d-flex align-items-center mr-3 text-nowrap">
                                          <img
                                            src={agent?.avatar?.location ? agent?.avatar?.location : BlankProPic}
                                            alt={
                                              agent?.avatar?.location ||
                                              "property image"
                                            }
                                            className="img-cover rounded-circle img-responsive mr-2"
                                            width="24"
                                            height="24"
                                          />
                                          {agent?.name}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </table>
                    </div>
                    {/* <div className="col-12 px-4 pt-3">
                        <span className="bg-white d-inline-block mr-2">
                          <button className="btn btn-outline-secondary px-4 font-normal font-weight-bold py-2 rounded">
                            Edit
                          </button>
                        </span>
                        <button className="btn btn-primary px-3 font-normal font-weight-bold py-2 rounded">
                          Create Site Visit Schedule
                        </button>
                      </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {detailModal.isOpen && (
                <PropertyDetailPage
                onClose={() => setDetailModal({})}
                projectId={detailModal.id}></PropertyDetailPage>
            )}
          <div className="modal-backdrop fade show"></div>
        </>
      </div>
    </AppLayout>
  );
};

export default ScheduleSiteVisitPreview;
